import { HStack } from "@ui/Stack";
import { For } from "solid-js";
import type { VideoEvidence } from "../../ChatEventTypes";
import "./CarouselVideoProgress.css";

type Props = {
	videoIndex: number;
	videoEvidence: VideoEvidence[];
	currentVideoProgressPercent: number;
	onSelectVideo: (index: number) => void;
};

const fillPercent = (
	activeIndex: number,
	slideIndex: number,
	progressPercent: number,
) => {
	if (slideIndex < activeIndex) {
		return 100;
	}
	if (slideIndex === activeIndex) {
		return Math.max(0, Math.min(100, progressPercent));
	}
	return 0;
};

export const CarouselVideoProgress = (props: Props) => {
	return (
		<HStack spacing="small" class="carousel-video-progress">
			<For each={props.videoEvidence}>
				{(_videoEvidence, index) => (
					<button
						type="button"
						aria-label={`Show video ${String(index() + 1)}`}
						classList={{
							"carousel-video-progress-item": true,
							"carousel-video-progress-item-active":
								index() === props.videoIndex,
							"carousel-video-progress-item-complete":
								index() < props.videoIndex,
						}}
						onClick={(event) => {
							event.stopPropagation();
							props.onSelectVideo(index());
						}}
					>
						<div
							class="carousel-video-progress-item__fill"
							style={{
								width: `${fillPercent(
									props.videoIndex,
									index(),
									props.currentVideoProgressPercent,
								)}%`,
							}}
						/>
					</button>
				)}
			</For>
		</HStack>
	);
};
